import { render } from "./colum-height.vue?vue&type=template&id=026b0da7"
import script from "./colum-height.vue?vue&type=script&lang=js"
export * from "./colum-height.vue?vue&type=script&lang=js"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__